import { createAsyncThunk } from "@reduxjs/toolkit";
import { normalize } from "normalizr";
import { thumbnailTemplate, thumbnailTemplateGroupedByDate } from "store/schemas";

import coreAPIs from "../../../services/api/core";

export const getThumbnailTemplates = createAsyncThunk("core/thumbnailTemplates/get", async (payload) => {
  try {
    const response = await coreAPIs.getThumbnailTemplates(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const createThumbnailTemplate = createAsyncThunk("core/thumbnailTemplates/create", async (payload) => {
  try {
    const response = await coreAPIs.createThumbnailTemplate(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getThumbnailTemplateGroupedByDate = createAsyncThunk(
  "core/thumbnailTemplates/getGroupedByDate",
  async (payload) => {
    try {
      const response = await coreAPIs.getThumbnailTemplateGroupedByDate(payload);
      const normalizedData = normalize(response?.data?.data?.items, [thumbnailTemplateGroupedByDate]);

      return {
        ...response.data,
        ...(response.data.statusCode === 200 ? normalizedData : {}),
      };
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getThumbnailTemplateById = createAsyncThunk("core/thumbnailTemplates/getById", async (payload) => {
  try {
    const response = await coreAPIs.getThumbnailTemplateById(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateThumbnailTemplateById = createAsyncThunk("core/thumbnailTemplates/updateById", async (payload) => {
  try {
    const response = await coreAPIs.updateThumbnailTemplateById(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteThumbnailTemplateById = createAsyncThunk("core/thumbnailTemplates/deleteById", async (payload) => {
  try {
    const response = await coreAPIs.deleteThumbnailTemplateById(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const createThumbnailTemplatePreset = createAsyncThunk(
  "core/thumbnailTemplates/createPreset",
  async (payload) => {
    try {
      const response = await coreAPIs.createThumbnailTemplatePreset(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getThumbnailTemplatePresets = createAsyncThunk("core/thumbnailTemplates/getPresets", async (payload) => {
  try {
    const response = await coreAPIs.getThumbnailTemplatePresets(payload);

    const normalizedData = normalize(response?.data?.data?.items, [thumbnailTemplate]);

    return {
      ...response.data,
      ...(response.data.statusCode === 200 ? normalizedData : {}),
    };
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteThumbnailTemplatePreset = createAsyncThunk(
  "core/thumbnailTemplates/deletePreset",
  async (payload) => {
    try {
      const response = await coreAPIs.deleteThumbnailTemplatePreset(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const createThumbnailTemplateImage = createAsyncThunk("core/thumbnailTemplates/createImage", async (payload) => {
  try {
    const response = await coreAPIs.createThumbnailTemplateImage(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getThumbnailTemplateImages = createAsyncThunk("core/thumbnailTemplates/getImages", async (payload) => {
  try {
    const response = await coreAPIs.getThumbnailTemplateImages(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteThumbnailTemplateImage = createAsyncThunk("core/thumbnailTemplates/deleteImage", async (payload) => {
  try {
    const response = await coreAPIs.deleteThumbnailTemplateImage(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getThumbnailTemplateByClipId = createAsyncThunk("core/thumbnailTemplates/getByClipId", async (payload) => {
  try {
    const response = await coreAPIs.getThumbnailTemplateByClipId(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
